import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import OrganizationService from '@forwardflow/services/OrganizationService'

import useSWR from 'swr'

export const useGetDefaultConfigurations = () => {
  const response = useSWR(
    [QUERY_KEYS.DEFAULT_CONFIG],
    () => OrganizationService.getDefaultConfigurations(),
    {
      shouldRetryOnError: false,
    }
  )
  return {
    ...response,
    mutate: () => response.mutate()
  }
}
